import { getCurrentInstance } from 'vue';
import type { ToastOptions } from '../components/ui/ToastContainer.vue';

let toastContainerInstance: any = null;

export function setToastContainer(instance: any) {
  toastContainerInstance = instance;
}

export function useToast() {
  const instance = getCurrentInstance();
  const container = toastContainerInstance || instance?.appContext.config.globalProperties.$toastContainer;

  const show = (options: ToastOptions) => {
    if (container) {
      container.addToast(options);
    } else {
      console.warn('ToastContainer not found. Make sure it is mounted in your app.');
    }
  };

  const success = (message: string, title?: string, duration = 3000) => {
    show({ message, title, type: 'success', duration });
  };

  const error = (message: string, title?: string, duration = 4000) => {
    show({ message, title, type: 'error', duration });
  };

  const warning = (message: string, title?: string, duration = 3500) => {
    show({ message, title, type: 'warning', duration });
  };

  const info = (message: string, title?: string, duration = 3000) => {
    show({ message, title, type: 'info', duration });
  };

  return {
    show,
    success,
    error,
    warning,
    info,
  };
}

